import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import LobIcon from '../../LobIcon';
import { LobCode } from '../../LobIcon/LobCode';
import { StyledContainerDiv, StyledRightDiv, StyledContentDiv, StyledLeftDiv, StyledTitle } from './Content.styles';

export interface ProductContentProps {
  lobCode: LobCode;
  productTypeTitle: string;
  children: ReactNode;
}

const ProductContent: FC<ProductContentProps> = ({ children, lobCode, productTypeTitle }) => {
  const ref = useRef<HTMLDivElement>();
  const [isLongTitle, setIsLongTitle] = useState(false);
  const oneLineHeight = 30;

  useEffect(() => {
    if (ref.current.clientHeight) setIsLongTitle(ref.current.clientHeight > oneLineHeight);
  }, []);

  return (
    <StyledContainerDiv>
      <StyledLeftDiv>
        <LobIcon code={lobCode} />
      </StyledLeftDiv>
      <StyledRightDiv isLongTitle={isLongTitle}>
        <div ref={ref}>
          <StyledTitle>{productTypeTitle}</StyledTitle>
        </div>
        <StyledContentDiv>{children}</StyledContentDiv>
      </StyledRightDiv>
    </StyledContainerDiv>
  );
};
export default ProductContent;
